const DEBUG = process.env.NODE_ENV === 'development';
export function log(str) {
  if (DEBUG) {
    console.info(str);
  }
}
